const choices = {
    optionOrOpcvm: 'Actions ou OPCVM ou trackers',
    ventureCapital: 'Capital Risque (actions non cotées, FCPR, FCPI, FIP, SCR)',
    dutiesOpcvm: 'Obligations ou OPCVM obligataires',
    realEstateProducts: 'Produits immobiliers (OPCI, SCPI)',
};

export default choices;
